import { DropdownMenuProps, Root } from "@radix-ui/react-dropdown-menu";

const Dropdown: React.FunctionComponent<DropdownMenuProps> = ({
  children,
  ...rest
}) => {
  return (
    <Root {...rest} modal={false}>
      {children}
    </Root>
  );
};

export default Dropdown;
